import React, { useEffect, useState } from "react";
import styled from "styled-components";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import upload from "../Assets/Img/upload.svg";

const Button = styled.button`
  /* Insert your favorite CSS code to style a button */
`;
const UploadFile = (props) => {
  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  function getBase64(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    });
  }

  const handleChange = async (event) => {
    if (props.typeFile.includes(event.target.files[0].type)) {
      console.log(event.target.files[0].type);
      if (event.target.files[0].type !=='application/pdf'){
              props.setErrorMessage(true);
      return;
      }


      const fileUploaded = event.target.files[0];
      setFile(fileUploaded);
      var base64File = await getBase64(fileUploaded);
      props.handleFile(base64File);
      props.setErrorMessage(false);
    } else {
      props.setErrorMessage(true);
    }
  };

  const [file, setFile] = useState();

  const [position] = useState(props.position ? props.position : "text-center");

  return (
    <>
      {!file && (
        <div
          style={{
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          <div
            className="upload-dragdrop-image"
            style={{ width: "100px", height: "100px" }}
          >
            <img alt="upload" aria-hidden="true" src={upload} />
            <div className="upload-dragdrop-loading">
              <div className="progress-donut" data-bs-progress-donut></div>
            </div>
            <div className="upload-dragdrop-success">
              <svg className="icon icon-primary icon-xs">
                <use href={`${iconSprite}#it-check`} />
              </svg>
            </div>
          </div>
          <div className="upload-dragdrop-text">
            <p className="upload-dragdrop-weight">
              <svg className="icon icon-primary icon-xs">
                <use href={`${iconSprite}#it-file`} />
              </svg>
            </p>
            <h5 style={{ fontSize: "1.222rem" }}>
              <u>{props.testoInterno ? props.testoInterno : "Carica ISEE"}</u>
            </h5>
          </div>

          <input
            type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: "none" }}
            accept=".pdf"
          />
        </div>
      )}

      {file && (
        <>
          <div
            className="upload-dragdrop-image"
            style={{ width: "100px", height: "100px" }}
          >
            <img alt="upload" aria-hidden="true" src={upload} height="50" />
            <div className="upload-dragdrop-loading">
              <div className="progress-donut" data-bs-progress-donut></div>
            </div>
            <div className="upload-dragdrop-success">
              <svg className="icon icon-primary icon-md">
                <use href={`${iconSprite}#it-check`} />
              </svg>
            </div>
          </div>
          <div className="upload-dragdrop-text">
            <p className="upload-dragdrop-weight">
              <svg className="icon icon-primary icon-xs">
                <use href={`${iconSprite}#it-file`} />
              </svg>
            </p>

            <div className="row mb-3">
              <div className="col-6">
                <h5>
                  <svg
                    className="icon icon-primary"
                    onClick={() => {
                      setFile(), props.handleFile();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <use xlinkHref={`${iconSprite}#it-file`}></use>
                  </svg>
                  <a>{file.name}</a>
                </h5>
              </div>
              <div className="col-6  text-center">
                <svg
                  className="icon icon-danger "
                  onClick={() => {
                    setFile(), props.handleFile();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <use xlinkHref={`${iconSprite}#it-close-circle`}></use>
                </svg>
              </div>
            </div>

            <div className="row ml-1">
              <div className="col-6">
                <h6 className="text-success">
                  {props.testoCaricamento
                    ? props.testoCaricamento
                    : "ISEE CARICATO CORRETTAMENTE"}
                </h6>
              </div>
              <div className="col-6 text-center">
                <h6 className="text-success">
                  <svg className="icon icon-success mx-2">
                    <use xlinkHref={`${iconSprite}#it-check-circle`}></use>
                  </svg>
                </h6>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default UploadFile;
